/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_SettingsInputs */



/**
* | output |
* | --- |
* | "Auto format settings" |
*
* @param {Auto_Format_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_settings = /** @type {((inputs?: Auto_Format_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres d’auto-formatage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen für automatische Formatierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di formattazione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки автоматического форматирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de formato automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動フォーマット設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो फॉर्मेट सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de formatação automática")
	return /** @type {LocalizedString} */ ("Auto format settings")
});